import { LogOut } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { businessService } from '@/services/business.service';

/**
 * Where an LMS-launched session ends. Learners from an LMS have no login,
 * and the login page cannot be shown inside the LMS frame anyway.
 */
export default function LtiSignedOut() {
  const { data: businessData } = useQuery({
    queryKey: ['businessSettings'],
    queryFn: () => businessService.getBusinessSettings(),
    staleTime: 5 * 60 * 1000,
  });
  const companyName = businessData?.data?.company_name?.trim() || businessData?.company_name?.trim() || 'Skillzen';

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4 py-8">
      <div className="text-center max-w-md space-y-4">
        <LogOut className="mx-auto h-12 w-12 text-primary-600" />
        <div>
          <p className="text-lg font-semibold text-gray-900">{`You've signed out of ${companyName}`}</p>
          <p className="text-gray-500 mt-2">
            {`To continue learning, open the ${companyName} activity again from your course in your learning platform (for example, Moodle).`}
          </p>
        </div>
      </div>
    </div>
  );
}
